import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import Button from "@ui/button/Button";
import { IconClose } from "@ui/icons/IconClose";
import Panel from "@ui/panel/Panel";
import { Typo } from "@ui/text/Typo";
import { useEffect, useState } from "react";
import { HBox, VBox } from "@ui/box/Box";
import { Error } from "@ui/error/Error";
import Signal from "badmfck-signal";
import { Rows } from "@ui/table/Rows";
import { fileInput } from "./AddFilesPopup";
import Input from "@ui/input/Input";
import { humanFileSize } from "src/utils/tools";
import { CommonDispatcher } from "src/services/Common";

export const S_ADD_COMMENT_POPUP = new Signal<{
	targetType: "client" | "clients";
	sectionType: number;
	targetId?: number;
	onChange?: () => void;
} | null>("S_ADD_COMMENT_POPUP");

export const AddCommentPopup = () => {
	useLocale();
	const requestData = S_ADD_COMMENT_POPUP.use();
	const [error, setError] = useState<IError>();

	const [filesToAdd, setFilesToAdd] = useState<File[]>([]);

	const [comment, setComment] = useState<{ value: string }>();
	const [busySend, setBusySend] = useState<boolean>();

	useEffect(() => {
		if (requestData) {
			setComment({
				value: "",
			});
		}
	}, [requestData]);

	const handleSubmit = async () => {
		if (requestData && comment) {
			setBusySend(true);

			const reqSave = await CommonDispatcher.REQ_COMMENT_ADD.request({
				sectionType: requestData.sectionType,
				targetType: requestData.targetType,
				targetId: requestData.targetId,
				value: comment.value,
				files: filesToAdd,
			});
			if (reqSave?.error) {
			} else {
				setComment({
					value: "",
				});
				closePopup();
				requestData.onChange && requestData.onChange();
			}

			setBusySend(false);

			//!TODO mark files with error (error.stack)
		}
	};

	const handleFileRemove = (f: File) => {
		const newFiles = filesToAdd.filter(val => val !== f);
		setFilesToAdd(newFiles);
	};

	const handleFileAdd = (_: any) => {
		setError(undefined);
		fileInput.onchange = _ => {
			if (fileInput.files) {
				const files = [];
				for (let i = 0; i < fileInput.files.length; i++) {
					const f = fileInput.files.item(i);
					if (!f) continue;
					if (filesToAdd.findIndex(val => val.name === f.name && val.size === f.size) > -1) continue;

					if (f.size > 99 * 1024 * 1024) continue;

					files.push(f);
				}
				let total = [...filesToAdd, ...files];
				if (total.length > 5) total = total.slice(0, 10);
				setFilesToAdd(total);
			}
			fileInput.value = "";
			fileInput.onchange = null;
			fileInput.oncancel = null;
		};
		fileInput.oncancel = _ => {
			fileInput.value = "";
			fileInput.onchange = null;
			fileInput.oncancel = null;
		};

		fileInput.click();
	};

	if (!requestData) return null;

	const closePopup = () => {
		S_ADD_COMMENT_POPUP.invoke(null);
		setError(undefined);
		setComment({
			value: "",
		});
		setFilesToAdd([]);
	};

	return (
		<Panel
			sx={{
				width: "500px",
				maxWidth: "1200px",
				height: "min-content",
				padding: "0",
				minWidth: "500px",
				minHeight: "300px",
				maxHeight: "90vh",
			}}
			growContent
			decorator="absolute"
			busy={busySend}
			label={msg("addComment")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "20px 20px",
					backgroundColor: "#EEF0F2",
				}}>
				{comment && <Input label={msg("comment")} type="textarea" name="value" data={comment} />}

				{filesToAdd && filesToAdd.length > 0 && (
					<VBox gap="10px">
						<Typo variant="headMedium" sx={{ color: "textSecondary" }}>{msg("attachments")}</Typo>
						<Rows
							data={
								filesToAdd.map(f => {
									return {
										name: f.name,
										size: f.size,
										close: "close",
										file: f,
									};
								}) ?? []
							}
							bulk={false}
							order={["name", "size", "close"]}
							cellFactory={(_row, cell, _index, _key, _name, _sx, _expanded, _rowID) => {
								if (_name === "name") {
									return {
										content: <Typo variant="text">{cell}</Typo>,
									};
								}
								if (_name === "close") {
									return {
										content: (
											<Button
												icon={<IconClose />}
												sx={
													{
														// position: "absolute",
														// top: "10px",
														// right: "10px",
													}
												}
												onClick={() => handleFileRemove(_row.file)}
											/>
										),
									};
								}

								if (_name === "size") {
									return {
										content: <Typo variant="text">{humanFileSize(_row.size, true)}</Typo>,
									};
								}

								return { content: cell };
							}}
						/>
					</VBox>
				)}
			</VBox>

			<VBox sx={{ padding: "20px", gap: "12px" }}>
				<Error error={error} />

				<HBox gap="10px">
					<Button disabled={busySend} title={msg("addAttachment")} onClick={handleFileAdd} />
					<Button
						disabled={busySend}
						title={msg("submit_155f816c")}
						onClick={() => {
							handleSubmit();
						}}
					/>
				</HBox>
			</VBox>
		</Panel>
	);
};
